import styled from "styled-components/native";

export const LinkText = styled.Text`
  color: #FFC829;
  font-family: "Open Sans";
`;
